
const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB']

export const formatCount = value => {
  const number = Number(value) || 0
  if (number < 1000) return String(number)
  if (number < 1000000) return `${(number / 1000).toFixed(number < 10000 ? 1 : 0)}k`
  return `${(number / 1000000).toFixed(number < 10000000 ? 1 : 0)}M`
}

export const formatBytes = value => {
  let number = Number(value) || 0
  let unit = 0

  while (number >= 1024 && unit < BYTE_UNITS.length - 1) {
    number /= 1024
    unit += 1
  }

  return `${number.toFixed(unit === 0 ? 0 : 1)} ${BYTE_UNITS[unit]}`
}

export const formatDuration = value => {
  const ms = Number(value) || 0
  return ms >= 1000 ? `${(ms / 1000).toFixed(2)}s` : `${Math.round(ms)}ms`
}

export const formatPercent = (value, digits = 2) => `${((Number(value) || 0) * 100).toFixed(digits)}%`

/** Error-rate colouring: green under 1%, amber under 5%, red beyond. */
export const errorRateVariant = rate => {
  const value = Number(rate) || 0
  if (value >= 0.05) return 'danger'
  if (value >= 0.01) return 'warning'
  return 'success'
}

export const statusVariant = status => {
  const code = Number(status) || 0
  if (code >= 500) return 'danger'
  if (code === 429) return 'warning'
  if (code >= 400) return 'warning'
  return 'success'
}

export const outcomeVariant = outcome => {
  if (outcome === 'server_error' || outcome === 'upstream_unavailable') return 'danger'
  if (outcome === 'rate_limited') return 'warning'
  if (outcome === 'ok') return 'success'
  return 'secondary'
}

export const outcomeLabel = outcome => String(outcome || '').replace(/_/g, ' ')

export const methodVariant = method => {
  if (method === 'GET' || method === 'HEAD') return 'info'
  if (method === 'POST') return 'primary'
  if (method === 'PUT' || method === 'PATCH') return 'warning'
  if (method === 'DELETE') return 'danger'
  return 'secondary'
}

export const WINDOW_PRESETS = [
  { label: 'Last 24 hours', hours: 24, granularity: 'hour' },
  { label: 'Last 7 days', hours: 24 * 7, granularity: 'day' },
  { label: 'Last 30 days', hours: 24 * 30, granularity: 'day' },
  { label: 'Last 90 days', hours: 24 * 90, granularity: 'day' },
]

export const windowParams = preset => {
  const to = new Date()
  const from = new Date(to.getTime() - preset.hours * 3600 * 1000)

  return {
    from: from.toISOString(),
    to: to.toISOString(),
    granularity: preset.granularity,
  }
}

/** Axis labels: hourly buckets want a time, daily buckets want a date. */
export const bucketLabel = (timestamp, granularity) => {
  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) return ''

  return granularity === 'hour'
    ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : date.toLocaleDateString([], { month: 'short', day: 'numeric' })
}
